import type {
  CDDInput, CDDReport, CaseListParams, CaseListResponse, EDDInput,
} from '@/types/profiler';
import { apiRequest as req } from '@/lib/apiRequest';

const BASE = '/v1/profiler';

export const profilerApi = {
  runCDD: (input: CDDInput) =>
    req<CDDReport>(`${BASE}/cdd`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  runEDD: (input: EDDInput) =>
    req<{ case_id: string; case_reference: string; status: string }>(`${BASE}/edd`, {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  getCase: (caseId: string) =>
    req<CDDReport>(`${BASE}/case/${caseId}/cdd`, { noRedirect: true }),

  listCases: (params: CaseListParams = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null) qs.set(k, String(v));
    });
    const query = qs.toString() ? `?${qs.toString()}` : '';
    return req<CaseListResponse>(`${BASE}/cases${query}`);
  },

  downloadReport: (caseId: string, track: 'aml' | 'dossier') =>
    req<Blob>(`${BASE}/report/${caseId}?track=${track}`, { responseType: 'blob' }),

  discardVariant: (caseId: string, value: string, undo = false) =>
    req<{ ok: boolean; value: string; discarded: boolean }>(
      `${BASE}/case/${caseId}/cluster/discard`,
      { method: 'PATCH', body: JSON.stringify({ value, undo }) },
    ),
};
